var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVibraUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#0E7716"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.17914 7.27642H6V12.7236H7.46939C7.46939 12.7236 10.1512 5.32614 10.263 5.3252C10.3571 5.32439 8.44898 15 8.44898 15H10.6984C10.6984 15 13.212 8.19951 13.3107 8.17073C13.4749 8.1228 12.839 12.7236 12.839 12.7236H13.9637L14 7.27642H12.5125C12.5125 7.27642 9.76758 14.7003 9.71882 14.6748C9.58719 14.6061 11.4966 5 11.4966 5H9.28345C9.28345 5 6.76655 11.7646 6.63492 11.9106C6.53431 12.0222 7.17914 7.27642 7.17914 7.27642Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVibraUserIcon);
export default __webpack_public_path__ + "static/media/vibra-user-icon.1ef61bcf55ab2572d36b898f1395f821.svg";
export { ForwardRef as ReactComponent };